import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('Sidebar dropdown controller connected')
    // Listen for clicks on dropdown buttons
    this.element.addEventListener('click', this.handleDropdownClick.bind(this))
  }

  handleDropdownClick(event) {
    const button = event.target.closest('[data-collapse-toggle]')
    if (!button) return

    console.log('Dropdown button clicked')

    const submenuId = button.getAttribute('data-collapse-toggle')
    const submenu = document.getElementById(submenuId)

    if (!submenu) {
      console.log('Submenu not found:', submenuId)
      return
    }

    console.log('Found submenu:', submenuId)

    // Wait for the dropdown animation to complete
    setTimeout(() => {
      // Check if the dropdown is now visible (opened)
      if (!submenu.classList.contains('hidden')) {
        console.log('Dropdown is now open, scrolling...')

        // Get the scrollable container (this.element)
        const container = this.element
        const submenuBottom = submenu.offsetTop + submenu.offsetHeight
        const containerBottom = container.scrollTop + container.clientHeight

        // If submenu extends beyond visible area, scroll to show it
        if (submenuBottom > containerBottom) {
          container.scrollTo({
            top: submenuBottom - container.clientHeight + 20,
            behavior: 'smooth'
          })
        }
      } else {
        console.log('Dropdown is hidden/closed')
      }
    }, 150)
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleDropdownClick)
  }
}
